exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table[data-v-e74498cc] {\n  width: 100%;\n  border-collapse: collapse;\n}\ntable th[data-v-e74498cc],\ntable td[data-v-e74498cc] {\n  border: 1px solid black;\n  padding: 8px;\n  text-align: center;\n}\n", ""]);

// exports
